module.exports = __webpack_public_path__ + "media/inv_ticket.733d5228.wav";